import {injectable} from 'inversify';

import {PrivateProfileModel} from './PrivateProfile.model';

@injectable()
export class PrivateProfileFactory {
  create(props: PrivateProfileModel.Props): PrivateProfileModel {
    return new PrivateProfileModel(props);
  }

  createEmpty() {
    return new PrivateProfileModel({
      additionalData: null,
      dateOfBirth: null,
      email: null,
      firstName: null,
      gender: null,
      isEmpty: true,
      lastName: null,
      location: null,
      middleName: null,
      partnerId: null,
      phone: null,
      reasonsForCoaching: null,
      timezone: null,
    });
  }
}
